<template>
  <v-form>
    <v-layout
      wrap>
      <v-flex md2 sm2 xs12>
        <v-select
          v-model="day"
          :items="days"
          label="曜日"
          v-validate="'required'"
          data-vv-name="day"
          data-vv-as="曜日"
          required
          :error-messages="errors.collect('day')"></v-select>
      </v-flex>
        <v-menu
          ref="startMenuRef"
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="start"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-flex
              md3
              sm3
              xs12>
            <v-text-field
              v-model="start"
              label="開始時刻"
              prepend-icon="access_time"
              readonly
              v-on="on"
              v-validate="'required'"
              data-vv-name="start"
              data-vv-as="開始時刻"
              required
              :error-messages="errors.collect('start')"
            ></v-text-field>
            </v-flex>
          </template>
          <v-time-picker
            v-if="startMenu"
            v-model="start"
            :allowed-minutes="allowedMinutes"
            full-width
            @click:minute="$refs.startMenuRef.save(start)"
          ></v-time-picker>
        </v-menu>
        <v-menu
          ref="endMenuRef"
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="end"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-flex
              md3
              sm3
              xs12>
            <v-text-field
              v-model="end"
              label="終了時刻"
              prepend-icon="access_time"
              readonly
              v-on="on"
              v-validate="'required'"
              data-vv-name="end"
              data-vv-as="終了時刻"
              required
              :error-messages="errors.collect('end')"
            ></v-text-field>
            </v-flex>
          </template>
          <v-time-picker
            v-if="endMenu"
            v-model="end"
            :allowed-minutes="allowedMinutes"
            full-width
            @click:minute="$refs.endMenuRef.save(end)"
          ></v-time-picker>
        </v-menu>
        <v-flex
          md4
          v-if="enableToAdd">
          <v-btn
            text
            icon
            small
            fab
            @click="addNewLine"
            >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            text
            icon
            small
            fab
            @click="deleteLine"
            >
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </v-flex>
    </v-layout>
  </v-form>
</template>

<script>

export default {
  name: "ScheduleSelector",
  props: {
    value: Object,
    enableToAdd: {
      type: Boolean,
      default: true
    }
  },
  inject: ['$validator'],
  data() {
    return {
      days: ['', '月', '火', '水', '木', '金', '土', '日'],
      startMenu: "",
      endMenu: ""
    }
  },
  methods: {
    addNewLine: function () {
      this.$emit("addNewLine")
    },
    deleteLine: function () {
      this.$emit("deleteLine")
    },
    allowedMinutes: m => m % 15 === 0,
  },
  computed: {
    day: {
      get() {
        return this.value.day
      },
      set(day) {
        this.newSchedule = {
          day: day,
          start: this.start,
          end: this.end
        }
      }
    },
    start: {
      get() {
        return this.value.start
      },
      set(start) {
        this.newSchedule = {
          day: this.day,
          start: start,
          end: this.end
        }
      }
    },
    end: {
      get() {
        return this.value.end
      },
      set(end) {
        this.newSchedule = {
          day: this.day,
          start: this.start,
          end: end
        }
      }
    },
    newSchedule: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  created: function () {
  }

}
</script>
